import React, { createContext, useState, useEffect } from "react";
import { Context } from "./Context/Context";

import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  BrowserRouter,
  Route,
  Link,
  Routes,
  Navigate,
  Switch,
  HashRouter,
} from "react-router-dom";
import Home from "./Components/Home";
import ViewAllListing from "./Components/ViewAllListing";
import ViewAllProjects from "./Components/ViewAllProjects";
import ProjectDetails from "./Components/ProjectDetails";

import { GoogleOAuthProvider } from "@react-oauth/google";
import PropertyDetailsNew from "./Components/PropertDetailsNew";
import NewProjects from "./Components/NewProjects";
import PostProperty from "./Components/PostProperty";
import PostPropertyNew from "./Components/PostPropertyNew";
import PropertyDetails from "./Components/PropertyDetails";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import About from "./Components/About";
import Terms from "./Components/Terms";
import Privacy from "./Components/Privacy";
import Chats from "./Components/Chats";
import Contact from "./Components/Contact";

const clientId =
  "473914031500-du4gugie3mb5ni4at61fi8tdkasabtuf.apps.googleusercontent.com"; // from Google Cloud Console

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId={clientId}>
     <ToastContainer />
    <Context>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/view-all-listing" element={<ViewAllListing />} />
          <Route path="/view-all-projects" element={<ViewAllProjects />} />
          <Route path="/property-details" element={<PropertyDetails  />} />
          <Route path="/property-details-new" element={<PropertyDetailsNew />} />
          <Route path="/project-details" element={<ProjectDetails />} />
          <Route path="/new-projects-and-developments" element={<NewProjects />} />
          <Route path="/post-property" element={<PostProperty />} />
            <Route path="/update-property" element={<PostProperty />} />
          <Route path="/post-property-new" element={<PostPropertyNew />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/terms-and-conditions" element={<Terms />} />
          <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/chats" element={<Chats />} />
            <Route path="/contactus" element={<Contact />} />
        </Routes>
      </BrowserRouter>
    </Context>
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
